export default __webpack_public_path__ + "static/media/logo_assets.4d76c863.png";